import { TableCell, styled } from "@mui/material";

export const EnhancedTableCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 700,
  width: 250,
}));